import { isNullish, Text, TooltipWrapper, Icon } from "@theorgchartdev/storybook";
import { FormatFieldValue } from "@coreapp/utils/FormatFieldValue";
import { PLACEHOLDER_TABLE_VALUE } from "@/Utils/Constants";
import { appstr } from "@coreapp/utils/appstr";
import { kBlockedFieldTag } from "@coreapp/constants";

export const TargetMetricInput = ({ rowState }) => {
  const targetValue = rowState?.data?.target;
  const currentValue = rowState?.data?.current;
  const fieldDef = rowState?.data?.fieldDef;
  const hasBlockedValue = currentValue === kBlockedFieldTag;

  const invalidValue = isNaN(targetValue) || isNullish(targetValue);

  if (targetValue === "" || invalidValue) {
    return (
      <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Text colorModifier={"gray"} size={"xsmall"}>
          {PLACEHOLDER_TABLE_VALUE}
        </Text>
        {targetValue !== "" && invalidValue && (
          <TooltipWrapper tooltipProps={{ message: appstr("Invalid target value") }}>
            <Icon name={"triangle-exclamation"} size={"xsmall"} modifier={"primary"} />
          </TooltipWrapper>
        )}
      </span>
    );
  }

  const value = hasBlockedValue ? kBlockedFieldTag : targetValue;
  const fullValue = FormatFieldValue(value, fieldDef);
  const compactValue = FormatFieldValue(value, fieldDef, null, 5, true);

  // Check if current value is over or under target
  let showArrow = false;
  let isOverTarget = false;
  let arrowTooltip = "";

  if (targetValue >= 0 && !isNaN(currentValue) && !isNullish(currentValue)) {
    let distanceToTarget = currentValue - targetValue;

    if (Math.abs(distanceToTarget) >= 1) {
      const fullDistance = FormatFieldValue(Math.abs(distanceToTarget), fieldDef);
      showArrow = true;
      isOverTarget = currentValue > targetValue;

      if (isOverTarget) {
        arrowTooltip = appstr("overtarget", { delta: fullDistance });
      } else {
        arrowTooltip = appstr("undertarget", { delta: fullDistance });
      }
    }
  }

  return (
    <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <TooltipWrapper tooltipProps={{ message: fullValue }}>
        <Text colorModifier={"gray"} size={"xsmall"}>
          {compactValue}
        </Text>
      </TooltipWrapper>
      {showArrow && (
        <TooltipWrapper tooltipProps={{ message: arrowTooltip }}>
          <Icon
            name={isOverTarget ? "arrow-up-regular" : "arrow-down-regular"}
            size="xsmall"
            layout="default"
          />
        </TooltipWrapper>
      )}
    </span>
  );
};
